import { render, staticRenderFns } from "./PeopleTable.vue?vue&type=template&id=ec220daa"
import script from "./PeopleTable.vue?vue&type=script&lang=js"
export * from "./PeopleTable.vue?vue&type=script&lang=js"
import style0 from "./PeopleTable.vue?vue&type=style&index=0&id=ec220daa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports